(() => {
  function protectPrivacyControls(event) {
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    const target = event.target instanceof Element ? event.target : null;
    if (!target?.closest('#shopify-pc__prefs__dialog, #shopify-pc__banner, a[href="#shopifyReshowConsentBanner"]')) return;
    if (typeof window.fbq === 'function') window.fbq('set', 'autoConfig', false);
  }
  document.addEventListener('pointerdown', protectPrivacyControls, true);
  document.addEventListener('keydown', protectPrivacyControls, true);
  document.addEventListener('click', protectPrivacyControls, true);
  const cookieDomains = [null, location.hostname, 'bb-haushaltsgeraete.de', '.bb-haushaltsgeraete.de'];
  function removeCookies(denied) {
    if (!denied.analytics && !denied.marketing) return;
    const names = document.cookie.split(';').map(part => part.trim().split('=')[0]);
    for (const name of names) {
      const analyticsCookie = /^_ga(?:_|$)/.test(name);
      const marketingCookie = name === '_fbp' || name === '_gcl_au';
      if (!(denied.analytics && analyticsCookie || denied.marketing && marketingCookie)) continue;
      for (const domain of cookieDomains) {
        document.cookie = name + '=; Max-Age=0; Path=/; SameSite=Lax; Secure' + (domain ? '; Domain=' + domain : '');
      }
    }
  }
  function applySavedChoice() {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return;
    const consent = privacy.currentVisitorConsent();
    removeCookies({ analytics: consent.analytics === 'no', marketing: consent.marketing === 'no' });
  }
  document.addEventListener('visitorConsentCollected', event => {
    const detail = event.detail || {};
    removeCookies({ analytics: detail.analyticsAllowed === false, marketing: detail.marketingAllowed === false });
  });
  if (window.Shopify?.customerPrivacy) {
    applySavedChoice();
  } else if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => {
      if (!error) applySavedChoice();
    });
  }
})();
